/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

/**
 * Common sitemap content types used by both Next.js apps and Cloudflare Workers.
 *
 * This file is intentionally kept separate from sitemap.utils.ts to avoid importing
 * @cosmos/hygraph-data which uses process.env at module load time
 * (incompatible with Cloudflare Workers runtime).
 */
export const commonSitemapContentTypes = [
	"cosmosPageAgreements",
	"cosmosPageBlogDetails",
	"cosmosPageEulaKeys",
	"cosmosPageFeeds",
	"cosmosPageHeroAndSections",
	"cosmosPageLegalContents",
	"cosmosPageLicenses",
	"cosmosPageSearches",
	"cosmosPageResearches",
	"cosmosPagePluginDetails",
];

/**
 * Content types that support owner filtering via the `owner` relation field.
 * Add new content types here as they gain owner support in Hygraph.
 */
export const ownerFilterableContentTypes = new Set(["cosmosPageHeroAndSections"]);
